import { useEffect, useRef, useState } from "react";
import { toast } from 'react-toastify';
import { usersAPI } from '../../api/usersAPI';
import Spinner from "../../components/spinner/spinner";

import '../logIn/login.css';

export default function SelectPcenter({ comCode, comName, defaultPcode, setLoggedPcode, setPcodeConfirmed }) {
    const [pcodes, setPcodes] = useState([]);
    const [selectedPcode, setSelectedPcode] = useState(defaultPcode || '');
    const [isLoading, setIsLoading] = useState(true);

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current === true) {
            isFirstRender.current = false;

            usersAPI.getPCentersByComCode(comCode).then((data) => {
                setPcodes(data);

                const isValidSelection = data.some((p) => p.pCode === selectedPcode);
                if (!isValidSelection) setSelectedPcode(data.length > 0 ? data[0].pCode : '');
            }).finally(() => setIsLoading(false));
        }
    }, [])

    const handleContinue = (e) => {
        e.preventDefault();

        if (!selectedPcode) { toast.warn("Please select a PCenter"); return; }

        setLoggedPcode(selectedPcode);
        setPcodeConfirmed(true);
    };

    return (
        <div className="col __height">
            <div className="row ccf d-flex justify-content-center align-items-center">
                <div className="col-1 col-sm-2 col-md-3 col-lg-4 col-xl-4 col-xxl-4"></div>
                <div className="col-10 col-sm-8 col-md-6 col-lg-4 col-xl-4 col-xxl-4 loginCard rounded text-center">
                    {isLoading === true && <Spinner />}
                    <form className={isLoading === true ? "visibility--hidden" : ""}>
                        <div className="row p-4">
                            <div className="col-12 p-0 text-center">
                                <h6>{comName}</h6>
                            </div>
                            <div className="col-12 mt-1 bg-dark line">
                                <p className="text-dark m-0">.</p>
                            </div>
                            <div className="col-12 mt-2">
                                <h5 className="text-dark m-0">Leave Management System</h5>
                            </div>
                            <div className="col-12 mt-3 p-0">
                                <select className="form-select" value={selectedPcode} onChange={(e) => setSelectedPcode(e.target.value)}>
                                    {
                                        pcodes.map((data) => (
                                            <option key={data.pCode} value={data.pCode}>{data.pName}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="col-12 mt-3 p-0">
                                <div className="row p-0">
                                    <div className="col-0 col-sm-0 col-md-8 col-lg-8 col-xl-8 col-xxl-8"></div>
                                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-end">
                                        <button onClick={handleContinue} type="submit" className="form-control btn btn-warning float-end">Continue</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="col-1 col-sm-2 col-md-3 col-lg-4 col-xl-4 col-xxl-4"></div>
            </div>
        </div>
    );
}
